'use client';

import type { FC } from 'react';
import { Credits } from './Credits';
import { formatUsd } from '../utils/formatters';

interface PriceDisplayProps {
  priceInCredits?: number;
  priceInUsd?: number;
}

export const PriceDisplay: FC<PriceDisplayProps> = ({ priceInCredits, priceInUsd }) => {
  // If only USD is provided, show it as the primary price
  if (priceInUsd !== undefined && priceInCredits === undefined) {
    return (
      <div className="flex flex-row items-center gap-1.5">
        <div className="text-base font-semibold text-white">{formatUsd(priceInUsd)}</div>
      </div>
    );
  }

  // If only credits are provided, show them
  if (priceInCredits !== undefined && priceInUsd === undefined) {
    return (
      <div className="flex flex-row items-center gap-1.5">
        <div>
          <Credits amount={priceInCredits} />
        </div>
      </div>
    );
  }

  // If both are provided, show credits as primary and USD as secondary
  return (
    <div className="flex flex-row items-center gap-1.5">
      <div>
        <Credits amount={priceInCredits!} />
      </div>
      {priceInUsd !== undefined && (
        <div className="text-xs font-medium text-muted">{formatUsd(priceInUsd)}</div>
      )}
    </div>
  );
};
